import { PageShell } from "@/components/PageShell";
import { Disclosure } from "@/components/Disclosure";

export default function DisclosurePage() {
  return (
    <PageShell>
      <Disclosure />
    </PageShell>
  );
}
